var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SeoHero'),_c('Seo1'),_c('Seo2'),_c('Seo3'),_c('Seo4'),_c('Seo5'),_c('Seo6'),_c('Seo7'),_c('Seo8'),_c('Seo9')],1)}
var staticRenderFns = []

export { render, staticRenderFns }